// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2i9MC","buttons":"SendReceipts_buttons__12E_q","email":"SendReceipts_email__jKboE","bookApptTitle":"SendReceipts_bookApptTitle__399UV"};